<div class="appContentsContainer">
  <form
    [formGroup]="maintenanceHistoricoBastidor"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm"
  >
    <div *ngIf="operation === 'edicion'" class="pageTitle">
      {{ "histoPlaca.editTitle" | translate }}
    </div>
    <div *ngIf="operation === 'creacion'" class="pageTitle">
      {{ "histoPlaca.createTitle" | translate }}
    </div>
    <div class="lineGradient"></div>
    <div class="row shortRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbBastidor" for="hbBastidor">Bastidor</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            id="hbBastidor"
            type="text"
            formControlName="hbBastidor"
            [readonly]="operation === 'edicion'"
            maxlength="17"
            minlength="9"
          />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbCodimag" for="hbCodimag">Código de imagen</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            id="hbCodimag"
            type="text"
            formControlName="hbCodimag"
            maxlength="4"
          />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbContrasena" for="hbContrasena">Contraseña </label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            id="hbContrasena"
            type="text"
            formControlName="hbContrasena"
            maxlength="25"
          />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbTipo" for="hbTipo">Tipo</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            id="hbTipo"
            type="text"
            formControlName="hbTipo"
            (input)="updateTipo($event)"
            maxlength="10"
          />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbVersion" for="hbTipo">Versión</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            id="hbVersion"
            type="text"
            formControlName="hbVersion"
            (input)="updateTipo($event)"
            maxlength="32"
          />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbVariante" for="hbVariante">Variante</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            id="hbVariante"
            type="text"
            formControlName="hbVariante"
            maxlength="25"
          />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbFechaalta" for="hbFechaalta">Fecha de alta</label>
          </div>
        </div>
        <div class="inputContainer">
          <input id="hbFechaalta" type="date" formControlName="hbFechaalta" />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="hbEmisionCo2">Emisión de CO2</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            id="hbEmisionCo2"
            type="text"
            formControlName="hbEmisionCo2"
            maxlength="6"
          />
        </div>

        <div class="supIndexRequest">*</div>
      </div>
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label>Patrón WLTP</label>
          </div>
        </div>
        <div class="inputContainer">
          <input
            class="smallInput"
            id="hbTipo"
            type="text"
            formControlName="hbTipo"
            (input)="updateTipo($event)"
            maxlength="10"
          />
          <input
            class="smallInput"
            id="hbMotor"
            type="text"
            formControlName="hbMotor"
            maxlength="4"
          />
          <input
            class="smallInput"
            id="hbCambio"
            type="text"
            formControlName="hbCambio"
            maxlength="8"
          />
          <input
            class="smallInput"
            id="hbCorrelativo"
            type="text"
            formControlName="hbCorrelativo"
            maxlength="6"
          />
        </div>
      </div>
    </div>

    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          *ngIf="maintenanceHistoricoBastidor.pristine"
          (click)="goList()"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
        <button
          class="formButtonBack"
          type="button"
          *ngIf="!maintenanceHistoricoBastidor.pristine"
          [swal]="confirmSwal"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
  </form>
</div>
